// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2d1LU","legacyBtn":"MutateMid_legacyBtn__2riZs"};